module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./RechargeAgentView.js"));
	}, "RechargeAgentView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RechargeAgentView!./src/pages/Store/Wallet/Recharge/RechargeAgent/RechargeAgentView.js
// module id = 1197
// module chunks = 438